import {
    Box,
    styled,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    DialogContentText as MuiDialogContentText,
    DialogActions as MuiDialogActions,
    Button as MuiButton
} from '@mui/material';
import color from 'src/theme/color';
import theme from 'src/theme';

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
`;

export const Attribute = styled(Box)`
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding-right: 8px;

    label {
        font-size: 12px;
        color: ${color.white50};
        margin-bottom: 4px;
        height: 20px;
        display: flex;
        align-items: center;
    }

    > span {
        color: ${color.white};
        font-size: 12px;
        white-space: nowrap;
    }

    flex: 0 0 auto;

    &:not(:last-child) {
        margin-right: 32px;
    }
`;

export const AttributeSection = styled(Box)`
    display: flex;
    flex-wrap: nowrap;
    margin-top: 16px;
`;

export const CircleButton = styled('button')`
    background: ${theme.color.greyYellow};
    border: none;
    cursor: pointer;
    display: flex;
    padding: 5px 5px 5px 5px;
    border-radius: 50%;
    color: ${theme.color.yellow60};
    width: 20px;
    height: 20px;
    align-items: center;
    vertical-align: middle;
    margin-left: 8px;

    svg {
        width: 20px;
        height: 20px;
        path {
            width: 20px;
            height: 20px;
            fill: ${theme.color.lightningYellow};
            transition: fill 0.2s ease;
        }

        &:hover path {
            fill: ${theme.color.yellow60};
        }
    }
`;

export const StyledDialogPaperProps = {
    style: {
        backgroundColor: theme.color.darkBlue,
        color: theme.color.white,
        borderRadius: '10px'
    }
};

export const ResumeDialogPaperProps = {
    style: {
        backgroundColor: theme.color.darkBlue,
        color: theme.color.white,
        borderRadius: '10px',
        width: '400px'
    }
};

export const PauseDialogPaperProps = {
    style: {
        backgroundColor: theme.color.darkBlue,
        color: theme.color.white,
        borderRadius: '10px',
        width: '400px'
    }
};

export const ArchiveDialogPaperProps = {
    style: {
        backgroundColor: theme.color.darkBlue,
        color: theme.color.white,
        borderRadius: '10px',
        width: '400px'
    }
};

export const RequireModificationsDialogPaperProps = {
    style: {
        backgroundColor: theme.color.darkBlue,
        color: theme.color.white,
        borderRadius: '10px',
        width: '400px'
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold'
});

export const DialogContent = styled(MuiDialogContent)({
    textAlign: 'center'
});

export const DialogContentText = styled(MuiDialogContentText)({
    textAlign: 'center',
    color: theme.color.white
});

export const DialogActions = styled(MuiDialogActions)({
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.color.white,
    gap: '8px'
});

export const YesButton = styled(MuiButton)({
    backgroundColor: theme.color.lightningYellow,
    color: theme.color.white,
    width: '80px',
    borderRadius: '40px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: theme.color.yellow60
    }
});

export const NoButton = styled(MuiButton)({
    backgroundColor: theme.color.blackRock,
    color: theme.color.white,
    width: '80px',
    borderRadius: '40px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: theme.color.darkBlueGrey
    }
});

export const PriorityLabelWrapper = styled('label')`
    display: flex;
    align-items: center;
    gap: 4px;
    height: 20px;
`;

export const InfoIconButton = styled('button')`
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 16px;

    &:hover {
        background-color: transparent;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const StatusContent = styled('div')`
    display: flex;
    align-items: center;
    height: 32px;

    span {
        color: ${color.white};
        font-size: 12px;
        white-space: nowrap;
    }
`;

export const DateContent = styled('span')`
    display: flex;
    align-items: center;
    height: 32px;
    color: ${color.white};
    font-size: 12px;
    white-space: nowrap;
`;

export const LlmAttributeContent = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 32px;
    color: ${color.white};
    font-size: 12px;
    white-space: nowrap;
`;

export const ViewSessionsButton = styled(MuiButton)`
    text-transform: none;
    color: ${color.white};
    border-color: ${color.white50};
    font-size: 11px;
    padding: 2px 8px;
    min-width: 0;
    height: 24px;
`;

export const PlanningActions = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    height: '32px'
});

export const MergeButton = styled(MuiButton)({
    minWidth: '120px',
    borderRadius: '20px',
    padding: '6px 18px',
    whiteSpace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    textTransform: 'none',
    height: '28px',
    backgroundColor: color.brightGreen,
    color: color.white,
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: color.brightGreen,
        opacity: 0.85,
        boxShadow: 'none'
    },
    '&&.Mui-disabled': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        color: color.white50
    }
});

export const DeleteQuestButton = styled(MuiButton)({
    borderRadius: '20px',
    padding: '8px 24px',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    minWidth: '120px',
    height: '32px',
    backgroundColor: color.brightRed,
    color: color.white,
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: color.moderateRed,
        boxShadow: 'none'
    },
    '&&.Mui-disabled': {
        backgroundColor: 'rgba(255, 92, 80, 0.4)',
        color: color.white50
    }
});
